import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

const MaintenanceFixingState = Immutable.fromJS({
    request: {
        target: null,
        mcase: null,
        card: null,
        type: null,
        appendType: null,
        checkSet: null,
        checkItem: null,
        note: '',

        sortOrders: {
            orderby: undefined,
            code: { by: "code", asc: undefined },
            status: { by: "status", asc: undefined },
            owner: { by: "owner", asc: undefined },
            unit: { by: "unit", asc: undefined },
            pantFixed: { by: "pantFixed", asc: undefined },
            clothesFixed: { by: "clothesFixed", asc: undefined }
        },
    },

    response: {
        categories: [],
        cases: [],
        cards: [],
        details: [],
        card: null,
        category: null,
        show: false,
    },
    options: {},
});

const maintenanceFixingReducer = handleActions({

    HIDE_APPEND_DETAIL_MODAL_AND_CLEAR: (state, { payload }) => {
        let respObject = state.get('response');
        respObject = respObject.set("show", false);
        respObject = respObject.set("category", null);

        let req = state.get('request');
        req = req.set("checkSet", null);
        req = req.set("checkItem", null);
        req = req.set("note", '');

        return state.merge({
            response: respObject,
            request: req,
        })
    },

    FIND_FIXABLE_MAINTENANCE_DETAILS: (state, { payload }) => {
        let respObject = state.get('response');
        respObject = respObject.set("details", payload.data.details);
        respObject = respObject.set("card", payload.data.card);
        return state.merge({
            response: respObject,
        })
    },

    SHOW_MAINTENANCE_MODIFY_COMPONENT_MODAL: (state, { payload }) => {
        let respObject = state.get('response');
        respObject = respObject.set("card", payload.card);
        respObject = respObject.set("category", payload.category);
        respObject = respObject.set("show", true);
        return state.merge({
            response: respObject,
        })
    },

    HIDE_MAINTENANCE_MODIFY_COMPONENT_MODAL: (state, { payload }) => {
        let respObject = state.get('response');
        respObject = respObject.set("category", null);
        respObject = respObject.set("show", false);
        return state.merge({
            response: respObject,
        })
    },

    ASSIGN_APPEND_CHECK_SET: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("checkSet", payload);
        return state.merge({
            request: req,
        })
    },

    ASSIGN_APPEND_CHECK_ITEM: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("checkItem", payload);
        return state.merge({
            request: req,
        })
    },

    ASSIGN_APPEND_CHECK_NOTE: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("note", payload);
        return state.merge({
            request: req,
        })
    },

    FIND_SORTED_FIXABLE_MAINTENANCE_CARDS: (state, { payload }) => {
        state = state.updateIn(['request', 'sortOrders', payload.order.get('by'), 'asc'],
            value => value == undefined ? false : !value);
        state = state.updateIn(['response', 'cards'], () => payload.cards);
        state = state.updateIn(['request', 'sortOrders', 'orderby'], () => payload.order.get('by'));

        return state.merge();
    },

    FIND_FIXABLE_MAINTENANCE_CARDS: (state, { payload }) => {
        let respObject = state.get('response');
        return state.merge({
            response: respObject.set("cards", payload.data),
        })
    },

    //Request
    FIND_FIXABLE_MCASES: (state, { payload }) => {
        let respObject = state.get('response');
        return state.merge({
            response: respObject.set("cases", payload.data),
        })
    },

    ASSIGN_FIXING_MCASE_TARGET: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("target", payload.id);
        req = req.set("mcase", payload);
        return state.merge({
            request: req,
        })
    },

    ASSIGN_APPEND_TARGET: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("card", payload.card);
        req = req.set("appendType", payload.appendType);

        let resp = state.get('response');
        resp = resp.set("card", payload.card);
        return state.merge({
            request: req,
            response: resp,
        })
    },

    ASSIGN_FIXING_CARD_TARGET: (state, { payload }) => {
        let req = state.get('request');
        req = req.set("card", payload.card.id);
        req = req.set("type", payload.type);

        let resp = state.get("response");
        resp = resp.set("card", payload.card);
        return state.merge({
            request: req,
            response: resp,
        })
    },

}, MaintenanceFixingState);

export default maintenanceFixingReducer;


// WEBPACK FOOTER //
// ./src/reducers/maintenanceFixingReducer.js